/**
 * SocketProxy class which implements the functions of a WebSocket. But instead of actually
 * emitting data via the WebSocket it will post message to parent window.
 *
 * The reason for this is specfially for embeds and only having all analytics sent via a single socket.
 * As there can live many embeds on a single page.
 */
class SocketProxy {
    isReady = false

    onmessage() {}

    onclose() {}

    send(data) {
        window.parent.postMessage(`youvisit:trackAnalytics:${data}`, '*')
    }

    sendMessage(action, message) {
        this.send(
            JSON.stringify({
                action,
                data: message,
            })
        )
    }

    open() {}

    close() {
        window.parent.postMessage('youvisit:connectionClosed', '*')
    }

    reconnect() {
        window.parent.postMessage('youvisit:connectionReconnected', '*')
    }
}

const PROXY = new SocketProxy()

export default PROXY
